/**
 * Module-level pub/sub for app-wide toasts. The single ToastProvider registers the emitter; both
 * useToast() and non-React callers (e.g. Http.js via emitGlobalToast) route through here. No-op
 * until an emitter is registered.
 */

let emitter = null;

export const setShowToastEmitter = (fn) => {
  emitter = typeof fn === "function" ? fn : null;
};

export const clearShowToastEmitter = () => {
  emitter = null;
};

// Full-signature dispatch for useToast(); `container` is accepted for compatibility but not forwarded.
export const dispatchToast = (
  message,
  alertType = "error",
  _container = null,
  toastDuration = 6000,
  action = null
) => {
  if (!message) return;
  if (emitter) emitter(message, alertType, toastDuration, action);
};

export const emitGlobalToast = (
  message,
  type = "error",
  duration = 6000
) => {
  dispatchToast(message, type, null, duration, null);
};
